/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css, cx } from "@panda/css";

import { CosmosVariableRichText, CosmosRichText, CosmosTextVariantEnum, CosmosTextAs } from "../..";

export interface CosmosDescProps {
	description?: CosmosVariableRichText | null;
	className?: string;
	as?: CosmosTextAs | null;
}

export const CosmosDesc = ({ description, className }: CosmosDescProps): React.JSX.Element | null => {
	let descEl = null;
	if (description?.html) {
		descEl = (
			<CosmosRichText
				{...description}
				variant={description?.variant || CosmosTextVariantEnum.paragraphMD}
				color={description?.color || "eds.text.secondary"}
				className={cx(
					className,
					css({
						"&& em": {
							fontStyle: "italic",
							paddingInlineEnd: "eds.dimension.4",
						},
					}),
				)}
			/>
		);
	}

	return descEl;
};
